export const defaultOptions = {
  exclude: 'bankAccountNumber'
};

export const defaultArrangedOptions = [
  'personalId',
  'firstName',
  'iban',
  'lastName',
  'email',
  'phone',
  'payrollId',
  'salaryType',
  'startDate',
  'contractEnd',
  'salary',
  'employeeStatus',
  'status',
  'subsidiary',
  'workingTimePercentage',
  'collectiveIds'
];
